import type { ClientsTranslations } from "../interfaces/clients";

export const clientsTranslations: ClientsTranslations = {
  page_title: "Clientes",
  page_subtitle: "Gerencie as organizações, seus clientes e o status de verificação de identidade.",
  button_refresh: "Atualizar",
  page_loading: "Carregando clientes...",
  filters_heading: "Filtros",
  filters_label_client_type: "Tipo de cliente",
  filters_placeholder_client_type: "Selecionar tipo de cliente",
  filters_label_kyc_status: "Estado KYC",
  filters_placeholder_kyc_status: "Selecionar estado",
  filters_label_country: "País",
  filters_placeholder_country: "Selecionar país",
  filters_label_search: "Buscar por nome",
  filters_placeholder_search: "Buscar por nome...",
  filters_hint: 'Os filtros são aplicados ao clicar em "Aplicar filtros".',
  filters_button_apply: "Aplicar filtros",
  filters_button_clear: "Limpar filtros",
  table_showing_one: "Mostrando 1 de {{total}}",
  table_showing_many: "Mostrando {{count}} de {{total}}",
  table_show_label: "Mostrar",
  table_th_type: "Tipo",
  table_th_name: "Nome",
  table_th_email: "E-mail",
  table_th_country: "País",
  table_th_kyc: "KYC",
  table_th_created: "Criado",
  table_th_actions: "Ações",
  table_empty: "Nenhum registro.",
  table_type_individual: "Individual",
  table_type_empresa: "Empresa",
  type_b2c: "B2C",
  type_b2b: "B2B",
  type_b2b2c: "B2B2C",
  kyc_pending: "Pendente",
  kyc_in_review: "Em revisão",
  kyc_verified: "Verificado",
  kyc_rejected: "Rejeitado",
  kyc_expired: "Expirado",
  pagination_records: "Registros {{from}} a {{to}} de {{total}}",
  pagination_total_pages: "Total de páginas ({{lastPage}})",
  pagination_first_page: "Primeira página",
  pagination_prev_page: "Página anterior",
  pagination_next_page: "Próxima página",
  pagination_last_page: "Última página",

  button_create_client: "Criar cliente",
  button_create_organization: "Criar organização",
  modal_create_title: "Criar cliente",
  modal_create_organization_title: "Criar organização",
  modal_label_parent_organization: "Organização",
  modal_placeholder_parent_organization: "Selecione a organização",
  modal_label_client_type: "Tipo de cliente",
  modal_placeholder_client_type: "Selecionar tipo de cliente",
  modal_label_first_name: "Nome",
  modal_placeholder_first_name: "Ex. João",
  modal_label_last_name: "Sobrenome",
  modal_placeholder_last_name: "Ex. Silva",
  modal_label_company_name: "Razão social",
  modal_placeholder_company_name: "Ex. Acme S.A.",
  modal_label_email: "E-mail",
  modal_placeholder_email: "Ex. email@exemplo.com",
  modal_label_phone: "Telefone",
  modal_placeholder_phone: "Ex. +55 11 99999 9999",
  modal_label_phone_dial: "Indicativo",
  modal_placeholder_phone_dial: "Selecione o país",
  modal_label_phone_national: "Número",
  modal_placeholder_phone_national: "Somente o número local, sem espaços",
  modal_label_country: "País",
  modal_placeholder_country: "Selecionar país",
  modal_label_identification_type: "Tipo de documento",
  modal_placeholder_identification_type: "Selecionar tipo",
  modal_label_identification_number: "Número do documento",
  modal_placeholder_identification_number: "Ex. 123456789",
  modal_cancel: "Cancelar",
  modal_create_button: "Criar",
  modal_creating: "Criando...",
  modal_close_aria: "Fechar",
  toast_create_client_success: "Cliente criado com sucesso.",
  toast_create_organization_success: "Organização criada com sucesso.",
  toast_create_client_duplicate: "Este cliente já existe nesta organização.",
  validation_client_type_required: "O tipo de cliente é obrigatório.",
  validation_first_name_required: "O nome é obrigatório.",
  validation_last_name_required: "O sobrenome é obrigatório.",
  validation_company_name_required: "A razão social é obrigatória.",
  validation_company_name_max: "Máximo 200 caracteres.",
  validation_company_name_min: "Mínimo de 2 caracteres.",
  validation_name_letters_only: "Apenas letras, espaços, apóstrofos e hífens são permitidos.",
  validation_email_required: "O e-mail é obrigatório.",
  validation_email_invalid: "Insira um e-mail válido.",
  validation_phone_required: "O telefone é obrigatório.",
  validation_phone_dial_required: "Selecione o indicativo do país.",
  validation_country_required: "O país é obrigatório.",
  validation_identification_type_required: "O tipo de documento é obrigatório.",
  validation_identification_number_required: "O número do documento é obrigatório.",
  validation_first_name_max: "Máximo 120 caracteres.",
  validation_last_name_max: "Máximo 120 caracteres.",
  validation_email_max: "Máximo 255 caracteres.",
  validation_phone_max: "Máximo 30 caracteres.",
  validation_identification_type_max: "Máximo 50 caracteres.",
  validation_identification_number_max: "Máximo 100 caracteres.",

  action_view: "Ver",
  action_accounts_aria: "Contas do cliente",
  accounts_modal_title: "Contas — {{name}}",
  accounts_loading: "Carregando contas...",
  accounts_error_load: "Não foi possível carregar as contas.",
  accounts_empty: "Este cliente não tem contas registradas.",
  accounts_section_list: "Contas registradas",
  accounts_section_new: "Registrar conta",
  accounts_btn_create: "Salvar conta",
  accounts_created_at: "Criada em",
  accounts_payment_method_bank: "Banco",
  accounts_payment_method_crypto: "Carteira cripto",
  accounts_payment_method_binance_pay: "Binance Pay",
  accounts_deleted: "Excluída",
  accounts_toast_success: "Conta registrada com sucesso.",
  accounts_toast_error: "Não foi possível registrar a conta.",
  accounts_validation_currency: "Selecione uma moeda.",
  accounts_validation_bank: "Selecione um banco ou método.",
  accounts_validation_payment_method: "Selecione um método de pagamento.",
  accounts_field_alias_label: "Apelido da conta",
  accounts_field_alias_placeholder: "Ex.: Conta principal BRL",
  accounts_validation_alias_max: "Máximo 255 caracteres.",
  accounts_btn_delete: "Excluir",
  accounts_delete_section_heading: "Conta a excluir",
  accounts_delete_no_metadata: "Sem informações adicionais",
  accounts_delete_confirm_title: "Excluir conta",
  accounts_delete_confirm_message:
    "Tem certeza de que deseja excluir esta conta? Esta ação não pode ser desfeita.",
  accounts_delete_final_confirm_title: "Confirmar exclusão",
  accounts_delete_final_confirm_message:
    "Confirme novamente. A conta será excluída permanentemente ao continuar.",
  accounts_delete_cancel: "Cancelar",
  accounts_delete_confirm: "Excluir",
  accounts_delete_final_confirm_button: "Sim, excluir conta",
  accounts_toast_delete_success: "Conta excluída com sucesso.",
  accounts_toast_delete_error: "Não foi possível excluir a conta.",
  view_modal_title: "Gestão KYC - {{name}}",
  view_label_name: "Nome",
  view_label_type: "Tipo",
  view_label_email: "E-mail",
  view_label_country: "País",
  view_label_phone: "Telefone",
  view_label_registration_date: "Data de registro",
  view_btn_generate_link: "Gerar verificação",
  view_btn_send_email: "Enviar por e-mail",
  view_toast_send_email_success: "E-mail de verificação KYC enviado.",
  view_toast_send_email_error: "Não foi possível enviar o e-mail de verificação.",
  view_loading: "Carregando cliente...",
  view_error: "Não foi possível carregar o cliente.",
  view_volver_cliente_padre: "Voltar ao cliente pai",

  view_btn_delete_client: "Excluir cliente",
  view_delete_client_confirm_title: "Excluir cliente",
  view_delete_client_confirm_message:
    'Tem certeza de que deseja excluir o cliente "{{name}}"? Esta ação não pode ser desfeita.',
  view_delete_client_section_heading: "Cliente a excluir",
  view_delete_client_final_confirm_title: "Confirmar exclusão",
  view_delete_client_final_confirm_message:
    'Confirme novamente. O cliente "{{name}}" será excluído permanentemente ao continuar.',
  view_delete_client_cancel: "Cancelar",
  view_delete_client_confirm: "Excluir",
  view_delete_client_final_confirm_button: "Sim, excluir",
  view_toast_delete_client_success: "Cliente excluído com sucesso.",
  view_toast_delete_client_error: "Não foi possível excluir o cliente.",
  view_delete_client_blocked_one: "Este cliente tem 1 conta bancária cadastrada. Exclua-a para continuar.",
  view_delete_client_blocked_many:
    "Este cliente tem {{count}} contas bancárias cadastradas. Exclua-as para continuar.",
  view_delete_client_blocked_action: "Ver contas bancárias",

  view_btn_delete_organization: "Excluir organização",
  view_delete_organization_confirm_title: "Excluir organização",
  view_delete_organization_confirm_message:
    'Tem certeza de que deseja excluir a organização "{{name}}"? O acesso aos seus clientes e contas será perdido. Esta ação não pode ser desfeita.',
  view_delete_organization_section_heading: "Organização a excluir",
  view_delete_organization_final_confirm_title: "Confirmar exclusão",
  view_delete_organization_final_confirm_message:
    'Confirme novamente. A organização "{{name}}" será excluída permanentemente ao continuar.',
  view_toast_delete_organization_success: "Organização excluída com sucesso.",
  view_toast_delete_organization_error: "Não foi possível excluir a organização.",
  view_delete_field_country: "País",
  view_delete_field_phone: "Tel.",
  view_danger_zone_action_delete: "Excluir",

  action_edit: "Editar cliente",
  edit_modal_title: "Editar cliente",
  edit_modal_description: "Atualize as informações do cliente.",
  edit_loading: "Carregando dados do cliente...",
  edit_error_load: "Não foi possível carregar os dados do cliente.",
  edit_field_type_label: "Tipo de cliente",
  edit_field_type_individual: "Individual",
  edit_field_type_business: "Empresa",
  edit_submit_button: "Salvar alterações",
  edit_submitting: "Salvando...",
  edit_no_changes: "Não há alterações para salvar.",
  edit_toast_success: "Cliente atualizado com sucesso.",
  edit_toast_error: "Não foi possível atualizar o cliente.",

  edit_org_modal_title: "Editar organização",
  edit_org_modal_description: "Atualize as informações da organização.",
  edit_org_label_name: "Nome da organização",
  edit_org_placeholder_name: "Ex. Acme S.A.",
  edit_org_toast_success: "Organização atualizada com sucesso.",
  edit_org_toast_error: "Não foi possível atualizar a organização.",
  validation_org_name_required: "O nome da organização é obrigatório.",
  validation_org_name_min: "Mínimo de 2 caracteres.",
  validation_org_name_max: "Máximo de 255 caracteres.",

  // Create client: identity (KYC) fields — Slice 3
  modal_section_company: "Dados da empresa",
  modal_section_owner: "Dados do proprietário",
  modal_label_birthdate: "Data de nascimento",
  modal_placeholder_birthdate: "AAAA-MM-DD",
  modal_label_gender: "Gênero",
  modal_placeholder_gender: "Selecionar gênero",
  gender_male: "Masculino",
  gender_female: "Feminino",
  gender_other: "Outro",
  modal_label_nationality: "Nacionalidade",
  modal_placeholder_nationality: "Selecionar país",
  modal_label_id_country: "País do documento",
  modal_placeholder_id_country: "Selecionar país",
  modal_label_legal_name: "Razão social",
  modal_placeholder_legal_name: "Ex.: Acme S.A.",
  modal_label_business_type: "Tipo de empresa",
  modal_placeholder_business_type: "Ex.: LTDA",
  modal_label_incorporation_date: "Data de constituição",
  modal_placeholder_incorporation_date: "AAAA-MM-DD",
  modal_label_owner_name: "Nome do proprietário",
  modal_placeholder_owner_name: "Ex.: Jane Smith",
  modal_label_owner_country_code: "País do proprietário",
  modal_placeholder_owner_country_code: "Selecionar país",
  modal_label_owner_id_type: "Tipo de documento do proprietário",
  modal_placeholder_owner_id_type: "Selecionar tipo",
  modal_label_owner_id_number: "Número de documento do proprietário",
  modal_placeholder_owner_id_number: "Ex.: 123456789",
  modal_label_owner_address_line1: "Endereço do proprietário",
  modal_placeholder_owner_address_line1: "Ex.: Rua 7 #8-9",
  modal_label_owner_city: "Cidade do proprietário",
  modal_placeholder_owner_city: "Ex.: Bogotá",
  modal_label_owner_state: "Estado do proprietário",
  modal_placeholder_owner_state: "Ex.: Cundinamarca",
  modal_label_owner_postal_code: "CEP do proprietário",
  modal_placeholder_owner_postal_code: "Ex.: 110111",
  doc_type_nit: "NIT",
  doc_type_cc: "CC",
  doc_type_ce: "CE",
  doc_type_ppt: "PPT",
  doc_type_passport: "Passaporte",
  doc_type_dni: "DNI",
  doc_type_le: "LE",
  doc_type_lc: "LC",
  doc_type_ci: "CI",
  doc_type_cuil: "CUIL",
  doc_type_rg: "RG",
  doc_type_cnh: "CNH",
  doc_type_cpf: "CPF",
  doc_type_cnpj: "CNPJ",
  doc_type_rut: "RUT",
  doc_type_ine: "INE",
  doc_type_rfc: "RFC",
  doc_type_ruc: "RUC",
  doc_type_national_id: "Documento nacional de identidade",
  doc_type_driver_license: "Carteira de motorista",
  doc_type_residence_permit: "Autorização de residência",
  doc_type_tax_id: "Identificação fiscal",
  validation_birthdate_required: "A data de nascimento é obrigatória.",
  validation_birthdate_invalid: "Informe uma data válida (AAAA-MM-DD).",
  validation_cpf_digits: "O CPF deve ter 11 dígitos.",
  validation_cnpj_length: "O CNPJ deve ter 14 caracteres.",
  validation_gender_required: "O gênero é obrigatório.",
  validation_id_country_required: "O país do documento é obrigatório.",
  validation_legal_name_required: "A razão social é obrigatória.",
  validation_legal_name_max: "Máximo 255 caracteres.",
  validation_business_type_required: "O tipo de empresa é obrigatório.",
  validation_business_type_max: "Máximo 100 caracteres.",
  validation_incorporation_date_required: "A data de constituição é obrigatória.",
  validation_incorporation_date_invalid: "Informe uma data válida (AAAA-MM-DD).",
  validation_owner_name_required: "O nome do proprietário é obrigatório.",
  validation_owner_country_code_required: "O país do proprietário é obrigatório.",
  validation_owner_id_type_required: "O tipo de documento do proprietário é obrigatório.",
  validation_owner_id_number_required: "O número de documento do proprietário é obrigatório.",
  validation_owner_address_line1_required: "O endereço do proprietário é obrigatório.",
  validation_owner_city_required: "A cidade do proprietário é obrigatória.",
  validation_owner_state_required: "O estado do proprietário é obrigatório.",
  validation_owner_postal_code_required: "O CEP do proprietário é obrigatório.",
  coming_soon: "Em breve",
  kpi_total_organizations: "Total de organizações",
  kpi_total_clients: "Total de clientes",
  kpi_total_meta: "Resultado da consulta atual",
  kpi_verified: "Verificados (KYC)",
  kpi_pending_review: "Pendentes / Em análise",
  kpi_rejected_expired: "Rejeitados ou expirados",
  filters_option_all: "Todos",
  filters_search_organizations_placeholder: "Buscar por nome ou email da organização…",
  filters_search_clients_placeholder: "Buscar por nome, email ou identificação…",
  filters_verified_only: "Somente verificados",
  filters_chip_search: "Busca",
  filters_chip_type: "Tipo",
  filters_chip_country: "País",
  filters_chip_remove: "Remover filtro {{label}}: {{value}}",
  filters_clear_all: "Limpar tudo",
  orgs_th_organization: "Organização",
  orgs_th_clients: "Clientes",
  orgs_th_accounts: "Contas",
  orgs_th_created: "Criada",
  orgs_count_clients: "clientes",
  orgs_count_accounts: "contas",
  orgs_action_view_clients: "Ver clientes",
  orgs_pagination_summary: "Mostrando {{from}}–{{to}} de {{total}} organizações",
  clients_pagination_summary: "Mostrando {{from}}–{{to}} de {{total}} clientes",
  pagination_show_label: "Mostrar",
  empty_no_results_title: "Não encontramos resultados com esses filtros",
  empty_no_results_description: "Tente ajustar a busca ou remover alguns filtros ativos.",
  empty_organizations_title: "Ainda não há organizações",
  empty_organizations_description: "Crie a primeira organização para começar a gerenciar clientes.",
  empty_clients_title: "Ainda não há clientes",
  empty_clients_description: "Crie o primeiro cliente desta organização para começar a operar.",
  error_retry: "Tentar novamente",
  drilldown_back: "Voltar",
  drilldown_accounts: "Contas",
  drilldown_edit_organization: "Editar organização",
  wizard_step_type: "Tipo",
  wizard_step_identity: "Identidade",
  wizard_step_details: "Dados",
  wizard_step_verify: "Verificar",
  wizard_step_company: "Dados da empresa",
  wizard_step_contact: "Contato e marca",
  wizard_step_owner: "Representante legal",
  wizard_progress_aria: "Progresso do assistente",
  wizard_back: "Voltar",
  wizard_continue: "Continuar",
  button_create_new: "Criar novo",
  modal_create_entity_title: "Criar novo",
  choice_entity_description: "Selecione o que você deseja registrar.",
  choice_card_organization_title: "Organização",
  choice_card_organization_description: "Registre um cliente empresarial e obtenha seu link de verificação.",
  choice_card_client_title: "Cliente",
  choice_card_client_description: "Registre uma pessoa ou empresa sob uma organização.",
  drawer_client_description: "Escolha o tipo de cliente.",
  drawer_client_individual_description: "Dados de identidade do indivíduo.",
  client_type_card_individual_description: "Uma pessoa física.",
  client_type_card_business_description: "Uma empresa ou entidade legal.",
  org_success_title: "Organização criada",
  org_success_subtitle: "Compartilhe o link de verificação.",
  org_success_text: "{{name}} foi criada com sucesso e sua identidade foi registrada.",
  org_success_kyc_pending:
    "A verificação de identidade (KYC) foi iniciada automaticamente. O status será atualizado conforme o processo avançar.",
  org_success_done: "Concluído",
  wizard_step_account: "Conta",
  client_success_title: "Cliente cadastrado",
  client_success_subtitle: "Compartilhe o link de verificação.",
  client_success_subtitle_account: "Compartilhe o link de verificação e adicione uma conta se precisar.",
  client_success_text: "{{name}} foi cadastrado com sucesso e sua identidade foi registrada.",
  client_success_kyc_pending:
    "A verificação de identidade (KYC) está pendente. Você pode gerar o link depois no detalhe do cliente.",
  client_success_skip: "Pular por enquanto",
  client_success_account_heading: "Adicionar uma conta em {{currency}} (opcional)",
  client_success_account_hint:
    "A conta ficará definida como destino desta dispersão; você poderá enviar quando o cliente concluir a verificação KYC.",
  accounts_drawer_assign_to: "A conta será atribuída a {{name}}.",
  kyc_link_title: "Link de verificação KYC",
  kyc_link_hint: "Compartilhe este link para concluir a verificação da Coloca. Não o divulgue.",
  kyc_link_hint_expires: "Este link é válido até {{date}}. Não o divulgue.",
  kyc_link_copy: "Copiar link",
  kyc_link_copied: "Copiado",
  kyc_section_eyebrow: "Verificação",
  kyc_section_title: "Verificação KYC",
  kyc_section_sub: "Status da verificação de identidade e link para concluí-la.",
  kyc_verified_on: "Verificação concluída em {{date}}.",
  kyc_documents_heading: "Documentos",
  kyc_document_view: "Ver",
  kyc_no_link: "Não há um link de verificação ativo para esta identidade.",
  kyc_rejection_reason: "Motivo da rejeição: {{reason}}",
  kyc_btn_regenerate: "Regenerar link",
  edit_identity_title: "Identidade verificada",
  edit_identity_full_name: "Nome completo",
  edit_identity_document: "Documento",
  edit_identity_birthdate: "Data de nascimento",
  edit_identity_incorporation_date: "Data de constituição",
  edit_identity_locked_caption: "Os dados de identidade estão verificados e não podem ser modificados aqui.",
  edit_section_contact: "Dados de contato",
};
